module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ListHeader', {
    attrs: {
      "title": "Layouts dos Certificados",
      "store-route-name": "layout.store"
    }
  }), _vm._v(" "), _c('ListMain', [_c('div', {
    attrs: {
      "slot": "filters"
    },
    slot: "filters"
  }, [_c('el-card', {
    staticClass: "el-card__search_list box-card"
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', [_vm._v("Filtrar")]), _vm._v(" "), _c('div', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onFilter
    }
  }, [_vm._v("Pesquisar")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "default"
    },
    on: {
      "click": _vm.onFilterClean
    }
  }, [_vm._v("Limpar")])], 1)]), _vm._v(" "), _c('el-form', {
    staticClass: "demo-form-inline",
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Nome"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Filtrar por nome"
    },
    nativeOn: {
      "keydown": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        $event.preventDefault();
        _vm.onFilter($event)
      }
    },
    model: {
      value: (_vm.filters.name),
      callback: function($$v) {
        _vm.$set(_vm.filters, "name", $$v)
      },
      expression: "filters.name"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), (!_vm.isLoadingData) ? _c('div', {
    attrs: {
      "slot": "list"
    },
    slot: "list"
  }, [_c('h2', [_vm._v("Lista de Campos")]), _vm._v(" "), _c('table', {
    staticClass: "custom-table-list"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("Nome")]), _vm._v(" "), _c('th', [_vm._v("Descrição")]), _vm._v(" "), _c('th', {
    staticClass: "btn-actions"
  }, [_vm._v("Ações")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.listStore.listData), function(item) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.description))]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "btn-actions"
    }, [_c('ListEditButton', {
      attrs: {
        "route-name": "layout.update",
        "item": item,
        "domain": "layout"
      }
    }), _vm._v(" "), _c('ListDeleteButton', {
      attrs: {
        "item": item,
        "domain": "layout"
      }
    })], 1)])])
  }))])]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6701ae95!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/domains/layout/components/List.vue
// module id = 760
// module chunks = 2